var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyclic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cyclic",
    transform: "translate(5.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    transform: "translate(-5.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M9.121,23.146A2.123,2.123,0,1,0,7,21.023a2.09,2.09,0,0,0,2.123,2.123",
    transform: "translate(-6.998 -15.358)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M80.223,23.146A2.123,2.123,0,1,0,78.1,21.023a2.119,2.119,0,0,0,2.123,2.123",
    transform: "translate(-58.346 -15.358)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M44.823,82.745A2.123,2.123,0,1,0,42.7,80.623a2.119,2.119,0,0,0,2.123,2.123",
    transform: "translate(-32.784 -58.745)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M68.858,38.8a2.584,2.584,0,0,1-.73.3,8.735,8.735,0,0,1-4.36,9.7,2.11,2.11,0,0,1-.228.114l-.114-.342h0L61.6,50.076l2.374.046h0l-.16-.457c.114-.046.205-.114.342-.183A9.626,9.626,0,0,0,68.4,44.8a9.835,9.835,0,0,0,.456-6",
    transform: "translate(-45.612 -28.107)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M10.155,40.034v-.251l.342.046L10.041,37.5,8.9,39.577l.479.068v.388a9.528,9.528,0,0,0,6.6,9.084v-.137a3.259,3.259,0,0,1,.068-.662,8.749,8.749,0,0,1-5.889-8.286",
    transform: "translate(-8.466 -27.104)",
    fill: "#c9d3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M38.772,7.789l-.4.365c-.116-.068-.26-.137-.4-.205a14.557,14.557,0,0,0-7.8-1.255A13.4,13.4,0,0,0,23.4,9.249a3.761,3.761,0,0,1,.722.525A13.327,13.327,0,0,1,37.472,8.633a2.746,2.746,0,0,1,.289.137l-.289.274,2.745.753Z",
    transform: "translate(-19.66 -6.602)",
    fill: "#c9d3f2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclic);
export default __webpack_public_path__ + "static/media/Cyclic.97eebaff84419a94366386039da12458.svg";
export { ForwardRef as ReactComponent };